import { render, staticRenderFns } from "./TheFixedTop.vue?vue&type=template&id=1b5d731c&scoped=true&"
import script from "./TheFixedTop.vue?vue&type=script&setup=true&lang=js&"
export * from "./TheFixedTop.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TheFixedTop.vue?vue&type=style&index=0&id=1b5d731c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d731c",
  null
  
)

export default component.exports